import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import InventoryGroup from './components/InventoryGroup';
import sortInPossessionsTabOrder from './sortInPossessionsTabOrder';

const withSortedPossessions = group => ({
  ...group,
  possessions: sortInPossessionsTabOrder(group.possessions),
});

function ProfileInventoryGroups({ profile }) {
  const expandedEquipped = withSortedPossessions(profile.expandedEquipped);
  const standardEquipped = withSortedPossessions(profile.standardEquipped);
  return (
    <Fragment>
      <div className="profile__inventory-group-container">
        <InventoryGroup
          data={standardEquipped}
          hideHeadings
          overrideLevels
          profile
        />
      </div>
      <div className="profile__inventory-group-container">
        <InventoryGroup
          data={expandedEquipped}
          hideHeadings
          overrideLevels
          profile
        />
      </div>
    </Fragment>
  );
}

ProfileInventoryGroups.displayName = 'ProfileInventoryGroups';

ProfileInventoryGroups.propTypes = {
  profile: PropTypes.shape({}).isRequired,
};

const mapStateToProps = ({ profile }) => ({
  profile,
});

export default connect(mapStateToProps)(ProfileInventoryGroups);